module.exports = __webpack_public_path__ + "img/pay-query-spinner.04d742e7.png";